/**
 * Offline cache for the static per-CAS parcours templates.
 *
 * The document-parcours preview shown at questionnaire completion is built from
 * GET /parcours/cas/:cas/template. Those templates are static per CAS code, so
 * we write them through to IndexedDB whenever they load online and read them
 * back when unreachable — letting a Relais complete the document phase in the
 * field and pre-set statuses that the outbox replays on reconnect.
 */

import { offlineDb } from './db.js';
import { OFFLINE_INTERACTION_ENABLED } from './offlineConfig.js';

// Document-parcours CAS codes (mirrors DOCUMENT_CAS_ORDER used across the app;
// the electoral-only CAS-E1/E2 have no document template to cache).
export const CACHEABLE_CAS_CODES = [
  'CAS-A', 'CAS-B', 'CAS-C', 'CAS-D', 'CAS-E', 'CAS-F', 'CAS-G', 'CAS-H',
];

export async function cacheCasTemplate(casNumero, payload) {
  if (!OFFLINE_INTERACTION_ENABLED || !casNumero || !payload) return;
  await offlineDb.cas_templates.put({
    casNumero: String(casNumero).trim(),
    payload,
    updatedAt: new Date().toISOString(),
  });
}

export async function getCachedCasTemplate(casNumero) {
  if (!OFFLINE_INTERACTION_ENABLED || !casNumero) return null;
  const row = await offlineDb.cas_templates.get(String(casNumero).trim());
  return row?.payload || null;
}
